export const COURSES = [
  {
    id: "bcom",
    code: "BCOM",
    name: "Bachelor of Commerce",
    subtitle: "Comprehensive foundation in commerce, corporate accounting, tax laws & financial management.",
    type: "UG",
    category: "Commerce & Finance",
    duration: "3 Years (6 Semesters)",
    durationYears: 3,
    totalFee: 160000,
    feePerSemester: 26666,
    emiStarts: 4444,
    rating: 4.8,
    reviewsCount: 320,
    badge: "Top Ranked",
    eligibility: "10+2 / HSC from a recognized board with minimum 50% aggregate marks.",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "UGC Entitled & WES Recognized 3-Year Degree",
      "Specializations in Corporate Accounting & FinTech",
      "Practical Exposure to Tally Prime & GST Filing",
      "Prepares for CA, CS, ACCA & CMA Foundation",
      "100% Online with Flexible Exam Slots"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Financial Accounting", "Business Organization & Management", "Microeconomics", "Business Communication"] },
      { sem: 2, title: "Semester 2", subjects: ["Advanced Financial Accounting", "Business Law", "Macroeconomics", "Business Mathematics"] },
      { sem: 3, title: "Semester 3", subjects: ["Corporate Accounting", "Business Statistics", "Income Tax Law & Practice", "Cost Accounting"] },
      { sem: 4, title: "Semester 4", subjects: ["Management Accounting", "Auditing & Corporate Governance", "Financial Markets & Services", "GST & Indirect Taxes"] },
      { sem: 5, title: "Semester 5", subjects: ["Financial Management", "International Business", "Corporate Tax Planning", "Elective Paper I"] },
      { sem: 6, title: "Semester 6", subjects: ["Strategic Management", "Financial Analytics", "Elective Paper II", "Capstone Project"] }
    ]
  },
  {
    id: "bca",
    code: "BCA",
    name: "Bachelor of Computer Applications",
    subtitle: "Master software development, cloud computing, full-stack web engineering & modern databases.",
    type: "UG",
    category: "IT & Software",
    duration: "3 Years (6 Semesters)",
    durationYears: 3,
    totalFee: 200000,
    feePerSemester: 33333,
    emiStarts: 5555,
    rating: 4.9,
    reviewsCount: 450,
    badge: "High Demand",
    eligibility: "10+2 / HSC pass in any stream from a recognized board (Mathematics/CS background preferred).",
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Hands-on Full Stack Development (React, Node, SQL)",
      "Virtual Coding Labs & Cloud Architecture Labs",
      "Curriculum Designed with Tech Leaders",
      "Prepares for Software Engineer & Web Developer Roles",
      "Access to Tech Mentors & Code Reviews"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Computer Fundamentals & C Programming", "Digital Logic & Computer Design", "Discrete Mathematics", "Technical English"] },
      { sem: 2, title: "Semester 2", subjects: ["Data Structures & Algorithms", "Object Oriented Programming with C++", "Database Management Systems (DBMS)", "Environmental Studies"] },
      { sem: 3, title: "Semester 3", subjects: ["Java Programming", "Web Technologies (HTML5/CSS3/JavaScript)", "Operating Systems", "Software Engineering Principles"] },
      { sem: 4, title: "Semester 4", subjects: ["Python Programming for Data Science", "Computer Networks & Security", "Advanced SQL & NoSQL Databases", "Cloud Computing Basics"] },
      { sem: 5, title: "Semester 5", subjects: ["Full Stack Development (Node.js & React)", "Mobile Application Development", "Information & Cyber Security", "Elective I"] },
      { sem: 6, title: "Semester 6", subjects: ["AI & ML Fundamentals", "DevOps & Cloud Architecture", "Elective II", "Major Industry Capstone Project"] }
    ]
  },
  {
    id: "msc-ds",
    code: "MSC-DS",
    name: "Master of Science in Data Science",
    subtitle: "Advanced program in machine learning, big data analytics, statistical modeling & predictive AI.",
    type: "PG",
    category: "Data & AI",
    duration: "2 Years (4 Semesters)",
    durationYears: 2,
    totalFee: 250000,
    feePerSemester: 62500,
    emiStarts: 6944,
    rating: 4.95,
    reviewsCount: 510,
    badge: "Best Seller",
    eligibility: "Bachelor's Degree (B.Sc / BCA / B.Tech / B.E. / B.Com with Math/Stats) with min 50% aggregate.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Practical Mastery in Python, R, Spark, TensorFlow & Tableau",
      "Industry Capstone Projects with Live Datasets",
      "Deep Learning, NLP & Computer Vision Specialization",
      "1-on-1 Placement Preparation & Resume Building",
      "Designed for Working Professionals"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Applied Statistics & Probability Theory", "Python & R Programming for Data Analytics", "Mathematical Foundations of Data Science", "Database Engineering & SQL"] },
      { sem: 2, title: "Semester 2", subjects: ["Machine Learning Algorithms & Models", "Exploratory Data Analysis & Data Wrangling", "Big Data Architecture (Hadoop/Spark)", "Multivariate Statistical Analysis"] },
      { sem: 3, title: "Semester 3", subjects: ["Deep Learning & Neural Networks", "Natural Language Processing (NLP)", "Data Visualization & Dashboarding (Tableau/PowerBI)", "Time Series Analysis & Forecasting"] },
      { sem: 4, title: "Semester 4", subjects: ["MLOps & Model Deployment Pipelines", "Computer Vision & Pattern Recognition", "AI Ethics & Data Governance", "Master's Capstone Project / Thesis"] }
    ]
  },
  {
    id: "msc-aiml",
    code: "MSC-AIML",
    name: "Master of Science in AI & Machine Learning",
    subtitle: "Cutting-edge degree covering Generative AI, Transformer Models, Neural Networks & Autonomous Systems.",
    type: "PG",
    category: "Data & AI",
    duration: "2 Years (4 Semesters)",
    durationYears: 2,
    totalFee: 275000,
    feePerSemester: 68750,
    emiStarts: 7638,
    rating: 4.98,
    reviewsCount: 380,
    badge: "Trending 2026",
    eligibility: "Graduation in CS/IT/Engineering/Science/Mathematics with minimum 50% aggregate.",
    image: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Focus on Generative AI, LLMs & Prompt Engineering",
      "Reinforcement Learning & Autonomous Agent Building",
      "PyTorch & TensorFlow GPU Virtual Labs",
      "Direct Placement Support from Top AI Labs",
      "WES & International Credential Evaluation Approved"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Advanced Python & AI Frameworks", "Linear Algebra & Mathematical Optimization", "Stochastic Processes & Bayesian Inference", "Data Structures for High-Performance AI"] },
      { sem: 2, title: "Semester 2", subjects: ["Supervised & Unsupervised Machine Learning", "Deep Neural Networks & PyTorch Architecture", "Computer Vision & Image Processing", "Pattern Recognition & Feature Engineering"] },
      { sem: 3, title: "Semester 3", subjects: ["Generative AI, LLMs & Transformer Models", "Natural Language Understanding (NLU)", "Reinforcement Learning & Decision Systems", "MLOps & Edge AI Deployment"] },
      { sem: 4, title: "Semester 4", subjects: ["Autonomous Systems & Robotics AI", "AI System Security & Robustness", "Elective Advanced AI Domain", "Capstone AI Industry Dissertation"] }
    ]
  },
  {
    id: "mca",
    code: "MCA",
    name: "Master of Computer Applications",
    subtitle: "Premium postgraduate IT degree preparing software architects, cloud engineers & IT leads.",
    type: "PG",
    category: "IT & Software",
    duration: "2 Years (4 Semesters)",
    durationYears: 2,
    totalFee: 230000,
    feePerSemester: 57500,
    emiStarts: 6388,
    rating: 4.9,
    reviewsCount: 420,
    badge: "Top Ranked",
    eligibility: "Passed BCA / B.Sc (CS/IT) or Bachelor's with Mathematics in 10+2 / Graduation.",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Enterprise Java, Spring Boot & Microservices",
      "Cloud Architectures on AWS & Azure",
      "DevOps, Docker, Kubernetes & CI/CD Pipelines",
      "Cybersecurity, Cryptography & Network Defense",
      "Industry Capstone Project & Mock Interviews"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Advanced Data Structures & Algorithms", "Enterprise Java & Frameworks (Spring)", "Modern Database Systems & NoSQL", "Computer Architecture & OS Internals"] },
      { sem: 2, title: "Semester 2", subjects: ["Cloud Computing Architecture (AWS/Azure)", "Web Microservices & REST API Design", "Software Architecture & Design Patterns", "Computer Networks & System Defense"] },
      { sem: 3, title: "Semester 3", subjects: ["DevOps, Containerization & Kubernetes", "Mobile App Development (Android/Flutter)", "Cyber Security & Digital Forensics", "Elective Specialization"] },
      { sem: 4, title: "Semester 4", subjects: ["Enterprise System Integration", "Blockchain & Distributed Systems", "Industry Internship & Capstone Software Project"] }
    ]
  },
  {
    id: "ma-econ",
    code: "MA-ECON",
    name: "Master of Arts in Applied Economics",
    subtitle: "Master quantitative economics, econometric analytics, policy analysis & financial forecasting.",
    type: "PG",
    category: "Humanities & Economics",
    duration: "2 Years (4 Semesters)",
    durationYears: 2,
    totalFee: 100000,
    feePerSemester: 25000,
    emiStarts: 2777,
    rating: 4.85,
    reviewsCount: 290,
    badge: "Affordable",
    eligibility: "Bachelor's Degree in any discipline from a recognized University with min 50% marks.",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Hands-on Econometric Modeling with STATA & R",
      "Policy Formulation & Economic Forecasting",
      "Curriculum Aligned with Central Banks & Global Consultancies",
      "100% Online with Live Faculty Interactions",
      "Flexible Weekend & Evening Learning Options"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["Microeconomic Analysis", "Macroeconomic Theory", "Mathematical Economics", "Statistical Methods for Economic Analysis"] },
      { sem: 2, title: "Semester 2", subjects: ["Econometric Methods & Modeling", "Applied Econometrics with STATA/R", "Development Economics & Policy", "Public Finance & Fiscal Policy"] },
      { sem: 3, title: "Semester 3", subjects: ["Financial Economics & Asset Pricing", "International Trade & Finance", "Environmental & Energy Economics", "Behavioral & Experimental Economics"] },
      { sem: 4, title: "Semester 4", subjects: ["Monetary Economics & Central Banking", "Economic Policy Analysis & Evaluation", "Master's Research Thesis / Dissertation"] }
    ]
  },
  {
    id: "ma-eng",
    code: "MA-ENG",
    name: "Master of Arts in English",
    subtitle: "Explore global literature, literary theory, linguistics, digital humanities & professional writing.",
    type: "PG",
    category: "Humanities & Languages",
    duration: "2 Years (4 Semesters)",
    durationYears: 2,
    totalFee: 75000,
    feePerSemester: 18750,
    emiStarts: 2083,
    rating: 4.8,
    reviewsCount: 210,
    badge: "Popular",
    eligibility: "Bachelor's Degree in any discipline from a recognized University.",
    image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?auto=format&fit=crop&w=800&q=80",
    keyHighlights: [
      "Comprehensive Coverage of World & Postcolonial Literature",
      "Digital Humanities, Media Studies & Content Strategy",
      "Mastery in Linguistics, Phonetics & Critical Thinking",
      "Ideal for Educators, Content Writers & Publishing Professionals",
      "Interdisciplinary Seminars with Renowned Authors"
    ],
    syllabus: [
      { sem: 1, title: "Semester 1", subjects: ["British Literature: Renaissance to Romantics", "Literary Theory & Critical Approaches", "Phonetics & English Linguistics", "Classical World Literature"] },
      { sem: 2, title: "Semester 2", subjects: ["Victorian & Modernist Literature", "American Literature & Culture", "Indian Writing in English", "Gender & Cultural Studies"] },
      { sem: 3, title: "Semester 3", subjects: ["Postcolonial Literature & Diaspora", "Subaltern & Resistance Literature", "Digital Humanities & New Media", "Translation Studies & Practice"] },
      { sem: 4, title: "Semester 4", subjects: ["Comparative Literature Frameworks", "Contemporary World Fiction", "Creative & Professional Editing", "Master's Research Dissertation"] }
    ]
  }
];

export const TRUST_STATS = [
  { value: "50+", label: "Years Academic Excellence", icon: "Award" },
  { value: "NAAC A+", label: "Grade Accreditation", icon: "ShieldCheck" },
  { value: "Category-1", label: "Autonomy Granted by UGC", icon: "GraduationCap" },
  { value: "100k+", label: "Global Active Alumni", icon: "Users" },
  { value: "100%", label: "Placement Support", icon: "Briefcase" }
];

export const WHY_CHRIST_FEATURES = [
  {
    id: "lms",
    title: "AI-Powered Learning Management System",
    description: "Access 24/7 self-paced e-content, high-definition video lectures, digital library, and interactive quizzes anytime from mobile or desktop.",
    icon: "MonitorPlay",
    highlights: ["Mobile App & Offline Access", "Automated Closed Captions & Notes", "Real-Time Progress Tracking"]
  },
  {
    id: "live",
    title: "Interactive Live & Recorded Webinars",
    description: "Learn directly from distinguished Christ University professors and top industry domain experts through interactive weekend sessions.",
    icon: "Video",
    highlights: ["Live Q&A Chat & Interactive Polls", "100% Archive Recordings Available", "Weekend & Evening Flexible Slots"]
  },
  {
    id: "mentorship",
    title: "Dedicated Academic & Career Mentors",
    description: "Receive personalized 1-on-1 mentorship, academic counseling, assignment guidance, and career profiling throughout your degree.",
    icon: "UserCheck",
    highlights: ["1-on-1 Office Hours", "Resume & LinkedIn Optimization", "Dedicated Helpdesk Support"]
  },
  {
    id: "exams",
    title: "100% Online Proctored Examinations",
    description: "Take mid-term and end-term examinations securely from the comfort of your home with flexible exam slot scheduling.",
    icon: "CheckCircle2",
    highlights: ["AI Remote Proctoring", "Select Preferred Exam Dates", "Instant Digital Grade Cards"]
  }
];

export const HIRING_PARTNERS = [
  { name: "Google", logo: "/uploads/google.jpeg", tag: "Tech & Search Leader" },
  { name: "Microsoft", logo: "/uploads/microsoft.png", tag: "Cloud & Software" },
  { name: "Meta", logo: "/uploads/meta.png", tag: "Social & AI Giant" },
  { name: "Intuit", logo: "/uploads/intuit.jpeg", tag: "Financial Tech" },
  { name: "SkillUp", logo: "/uploads/skillup.png", tag: "EdTech & Skill Building" },
  { name: "Deloitte", tag: "Big 4 Consulting" },
  { name: "EY", tag: "Global Assurance" },
  { name: "KPMG", tag: "Financial Services" },
  { name: "Amazon", tag: "Tech & Cloud" },
  { name: "Infosys", tag: "IT Services" },
  { name: "TCS", tag: "Global Consulting" },
  { name: "Wipro", tag: "Digital Transformation" },
  { name: "Accenture", tag: "Strategy & Tech" }
];

export const ACCREDITATIONS = [
  {
    id: "naac",
    name: "NAAC Grade A+",
    title: "NAAC 'A+' Grade",
    category: "Accreditation",
    description: "Accredited with highest NAAC A+ Grade by UGC",
    image: "/uploads/naac_20250802053353.jpg"
  },
  {
    id: "nirf",
    name: "NIRF Ranking",
    title: "NIRF Ranked",
    category: "Government Ranking",
    description: "Ranked among Top Universities by MoE Govt of India",
    image: "/uploads/nirt_20250802063103.jpg"
  },
  {
    id: "qs-2025",
    name: "QS World 2025",
    title: "QS World Ranking 2025",
    category: "Global Ranking",
    description: "Recognized in QS World University Rankings 2025",
    image: "/uploads/qs-25_20250802063250.jpg"
  },
  {
    id: "qs-asia",
    name: "QS Asia Rankings",
    title: "QS Asia University Ranking",
    category: "Continental Ranking",
    description: "Top Ranked Asian Higher Education Institution",
    image: "/uploads/qs_20250802063157.jpg"
  },
  {
    id: "ugc",
    name: "UGC Entitled",
    title: "UGC Category-1",
    category: "Regulatory Approval",
    description: "Category-1 Autonomy Granted by University Grants Commission",
    image: "/uploads/un_20250802063513.jpg"
  },
  {
    id: "wuri",
    name: "WURI Ranking",
    title: "WURI Global Ranking",
    category: "Innovation Ranking",
    description: "World's Universities with Real Impact Innovation Ranking",
    image: "/uploads/wuri1_20250701104637_20250808103637.jpg"
  },
  {
    id: "ses",
    name: "SES Institution",
    title: "SES Certification",
    category: "Social Enterprise",
    description: "Certified Social Entrepreneurship & Sustainability Institution",
    image: "/uploads/ses_20250802063436.jpg"
  }
];

export const TESTIMONIALS = [
  {
    name: "Rohan Mukherjee",
    role: "Data Analyst at Deloitte",
    course: "M.Sc Data Science (Batch of 2025)",
    rating: 5,
    text: "The M.Sc Data Science program at Christ Online was transformative. Balancing my job with studies was effortless thanks to recorded lectures and weekend live webinars. The industry projects were top-notch!",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80"
  },
  {
    name: "Ananya Sharma",
    role: "Software Engineer at Infosys",
    course: "BCA Online (Batch of 2024)",
    rating: 5,
    text: "Christ University's online BCA gave me the exact technical edge I needed. Virtual labs, project guidance, and placement prep helped me land 3 job offers during campus placement drives.",
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=300&q=80"
  },
  {
    name: "Vikramaditya Rao",
    role: "Financial Analyst at KPMG",
    course: "B.Com Online (Batch of 2025)",
    rating: 5,
    text: "The B.Com degree is UGC Entitled and recognized globally. The faculty's clarity on corporate tax laws and financial modeling was world-class. Highly recommended!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80"
  }
];

export const FAQS = [
  {
    category: "Accreditation & Validity",
    question: "Are Christ University online degrees UGC entitled and equivalent to regular degrees?",
    answer: "Yes, absolutely. All online undergraduate and postgraduate degree programs offered by CHRIST (Deemed to be University) are UGC Entitled under UGC (Open and Distance Learning Programmes and Online Programmes) Regulations. As per UGC directives, degrees earned through online mode are at par with degrees obtained through conventional on-campus mode."
  },
  {
    category: "Accreditation & Validity",
    question: "Is the online degree recognized by WES and international bodies?",
    answer: "Yes. Christ University is a NAAC 'A+' Grade accredited Category-1 deemed university. Our online degrees are recognized by WES (World Education Services), AIU (Association of Indian Universities), and international accreditation bodies for higher studies and global employment."
  },
  {
    category: "Examinations & Learning",
    question: "How are exams conducted for online programs?",
    answer: "Examinations are conducted 100% online through secure AI-proctored examination software. Students can take exams comfortably from home using a laptop/computer with a webcam and stable internet connection."
  },
  {
    category: "Examinations & Learning",
    question: "What is the mode of classes and time commitment?",
    answer: "Classes are delivered via live interactive weekend webinars and self-paced LMS learning content. You can expect a commitment of approximately 8 to 10 hours per week, making it ideal for working professionals and full-time learners alike."
  },
  {
    category: "Fees & EMI Options",
    question: "Are flexible fee installment and No-Cost EMI options available?",
    answer: "Yes! Christ University Online offers flexible semester-wise fee payment options as well as easy monthly No-Cost EMI options starting as low as ₹2,083/month in partnership with leading financial institutions."
  },
  {
    category: "Placements & Career",
    question: "Does Christ University provide placement assistance for online students?",
    answer: "Yes, all enrolled online students get full access to the Placement Cell. Services include resume profiling, LinkedIn optimization, mock interview workshops, soft skills training, and direct placement drives with 500+ corporate hiring partners."
  }
];
